document.addEventListener('DOMContentLoaded', function() {

  gsap.registerPlugin(ScrollTrigger);


    gsap.from('#shopify-section-template--27253841658154__custom_html_3x6a4h .fb-feature-item', {
    scrollTrigger: {
      trigger: '#shopify-section-template--27253841658154__custom_html_3x6a4h .fb-feature-item',
      start: 'top 80%'
    },
    opacity: 0,
    y: 50,
    duration: 0.5,
    stagger:0.4,
    ease: 'power2.out'
  });

      gsap.from('#shopify-section-template--27253841658154__text_columns_with_images_dVGNCk .one-third', {
    scrollTrigger: {
      trigger: '#shopify-section-template--27253841658154__text_columns_with_images_dVGNCk .one-third',
      start: 'top 80%'
    },
    opacity: 0,
    y: 50,
    duration: 0.5,
    stagger:0.4,
    ease: 'power2.out'
  });


    gsap.from('#shopify-section-template--27253841658154__image_text_cwEfYd .info', {
    scrollTrigger: {
      trigger: '#shopify-section-template--27253841658154__image_text_cwEfYd .info',
      start: 'top 80%'
    },
    opacity: 0,
    x: -200,
    duration: 1,
    ease: 'power2.out'
  });

      gsap.from('#shopify-section-template--27253841658154__image_text_cwEfYd img', {
    scrollTrigger: {
      trigger: '#shopify-section-template--27253841658154__image_text_cwEfYd img',
      start: 'top 80%'
    },
    opacity: 0,
    duration: 2,
    ease: 'power2.out'
  });


        gsap.from('.ep-feature', {
    scrollTrigger: {
      trigger: '.ep-feature',
      start: 'top 80%'
    },
    opacity: 0,
    y: 50,
    duration: 0.5,
    stagger:0.4,
    ease: 'power2.out'
  });



const track = document.querySelector('.fb-slider-track');

// Clone everything once
track.innerHTML += track.innerHTML;

gsap.to(track, {
  x: () => -(track.scrollWidth / 2),
  duration: 30,
  ease: "none",
  repeat: -1
});


});

